import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PrematchContext from '../../contexts/PrematchContext';
import { fetchBetsForTournaments, printExtraBets } from '../../data/fetchBetsForTournaments';
import { deepCopyBet, filterEntries, getBetDescription, getSysDateInFormat } from '../../data/utils';
import { getLabel } from '../../InitData';
import { PrematchDataContext } from '../PrematchDataFetcher';
import PrintIframeContent from './PrintIframeContent';
import { compactBets } from '../../data/parseBetsData';

export function getMapFromBets(bets) {
    const result = {};
    bets.forEach(bet => {
        const betId = `${bet.id}_${bet.handicap}`;
        result[betId] = bet;
    });
    return result;
}

function PrintOdds(props) {
    const prematchContext = useContext(PrematchContext);
    const prematchData = useContext(PrematchDataContext);
    const [filter, setFilter] = useState('');
    const iframeRef = useRef(null);
    let bets = [];
    let betsById = new Map();
    const mainBets = [];

    {
        let aggs = new Map();
        const aggById = new Map();
        const aggBetsMap = new Map();
        if (prematchContext.tournamentsToPrint) {
            const sport = props.data.sportById[prematchContext.tournamentsToPrint[0].sportRef];
            const sportDesc = sport.descrizione;
            prematchContext.tournamentsToPrint.forEach(t => {
                t.sportDesc = sportDesc;
                t.categoryDesc = sport.categoryById[t.categoryRef].descrizione;
                t.aggregate.forEach(ag => {
                    const aggId = ag.idAggregata;
                    if (!aggs.has(aggId)) {
                        aggById.set(aggId, ag);
                        aggs.set(aggId, []);
                        aggBetsMap.set(aggId, new Set());
                    }

                    const betsMap = aggBetsMap.get(aggId);
                    ag.scommesse.forEach(bet => {
                        const betId = `${bet.id}_${bet.handicap}`;

                        if (!betsMap.has(betId)) {
                            betsMap.add(betId);

                            const printBet = deepCopyBet(bet);
                            printBet.desc = getBetDescription(printBet, true);
                            printBet.agId = aggId;
                            printBet.agRanking = ag.ranking;
                            printBet.sportRef = t.sportRef;
                            printBet.categoryRef = t.categoryRef;
                            printBet.tournamentRef = t.id;
                            aggs.get(aggId).push(printBet);
                        }
                    });
                });
            });

            betsById = new Map();
            aggs.forEach((aggBets, aggId) => {
                const agg = aggById.get(aggId);
                if (agg.compattate != null && Object.values(agg.compattate).length > 0) {
                    aggBets = compactBets(aggBets, agg, false);
                }

                if (agg.isPrincipale) {
                    mainBets.push(...aggBets);
                }

                aggBets.forEach(bet => {
                    const betId = `${bet.id}_${bet.handicap}`;
                    if (!betsById.has(betId)) {
                        betsById.set(betId, bet);
                        bets.push(bet);
                    }
                });
            });
        }
    }

    if (filter != null && filter.length > 0) {
        bets = filterEntries(bets, filter, (bet) => bet.desc);
    }

    const [state, setState] = useState({
        selections: mainBets.length,
        selectedBets: getMapFromBets(mainBets),
        groups: null,
        groupById: null,
        settings: {
            align: 'vertical',
            fontSize: 'medium',
            sortType: 'date',
            range: 'ALL',
            dateFrom: null,
            dateTo: null,
            logoOnAllPages: true
        },
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        toggleBet(betId, bet) {
            if (this.selectedBets[betId] === undefined) {
                this.selectedBets[betId] = bet.isCompact ? betsById.get(betId) : bet;
                this.selections++;
            } else {
                delete this.selectedBets[betId];
                this.selections--;
            }
            this.update({selectedBets: this.selectedBets});
        },
        toggleAll() {
            let selectedBets = [];
            let selections = 0;
            if (this.selections < bets.length) {
                selectedBets = getMapFromBets(bets);
                selections = bets.length;
            }
            this.update({selectedBets, selections});
        },
        setFontSize(fontSize) {
            this.update({settings: {...this.settings, fontSize}});
        },
        setAlignment(align) {
            this.update({settings: {...this.settings, align}});
        },
        setSortType(sortType) {
            this.update({settings: {...this.settings, sortType}});
        },
        setRange(range, dateFrom, dateTo) {
            this.update({settings: {...this.settings, range, dateFrom, dateTo}});
        },
        setDateFrom(dateFrom) {
            this.update({settings: {...this.settings, dateFrom}});
        },
        setDateTo(dateTo) {
            this.update({settings: {...this.settings, dateTo}});
        },
        setData(groups, groupByBet) {
            this.update({groups, groupByBet});
        },
        setLogoOnAllPages(enabled) {
            this.update({settings: {...this.settings, logoOnAllPages: enabled}});
        }
    });
    const [togglePrint, setTogglePrint] = useState(false);

    function handleCheckAll() {
        state.toggleAll();
    }

    function handlePrint() {
        if (prematchContext.tournamentsToPrint != null) {
            const betsToPrint = Object.values(state.selectedBets).sort((a, b) => {
                if (a.agRanking === b.agRanking) {
                    return a.ranking - b.ranking;
                } else {
                    return a.agRanking - b.agRanking;
                }
            });
            if (betsToPrint.length === 0) {
                return;
            }
            const sett = state.settings;
            fetchBetsForTournaments(prematchContext.tournamentsToPrint, betsToPrint, sett.range, sett.dateFrom, sett.dateTo, function(resp) {
                state.setData(resp[0], resp[1]);
                if (resp[0].length > 0) {
                    setTogglePrint(!togglePrint);
                }
            });
        } else {
            printExtraBets(prematchData, prematchContext.extraOdds, function(resp) {
                state.setData(resp[0], resp[1]);
                if (resp[0].length > 0) {
                    setTogglePrint(!togglePrint);
                }
            });
        }
    }

    useEffect(() => {
        if (state.groups) {
            setTimeout(() => {
                iframeRef.current.contentWindow.print();
            }, 500);
        }
    }, [togglePrint]);

    function handleClose(e) {
        window.openSection('prematch');
    }

    function setDateFrom(e) {
        if (e.target) {
            state.setDateFrom(e.target.value);
        }
    }

    function setDateTo(e) {
        if (e.target) {
            state.setDateTo(e.target.value);
        }
    }

    const todayDate = getSysDateInFormat('YYYY-MM-DD', 0);
    const tomorrowDate = getSysDateInFormat('YYYY-MM-DD', 1);

    return (
        <div className="griglia-centrale-sport col stringimento-sidebar sel-sport-centrale" id="div-centrale">
            <div className="box-grande-sel">
                <div className="w-100 titolo-sport-stampa">
                    <h2 className="margine-giu grassetto"><i className="fas fa-print margine-dx"></i>{getLabel('prematch_page.print_bets.bets_selection_window.title')}</h2>
                    {prematchContext.tournamentsToPrint != null &&
                        <p className="grigio-scuro ">{getLabel('prematch_page.print_bets.bets_selection_window.subtitle')}</p>   
                    } 
                </div>
                <div className="w-100 selezione-sport-box">
                    {prematchContext.tournamentsToPrint != null &&
                        <div className="box-paese margine-giu lista-stampabili">
                            <div className="d-flex align-items-center justify-center mb-4">
                                <input className="form-control d-inline w-50 ml-auto mr-auto" placeholder={getLabel('general.find')} onChange={(e) => setFilter(e.target.value)} autoFocus />
                            </div>
                            {bets.length > 0 ?
                                <ul className="p-4">
                                    {bets.map((bet, i) => {
                                        const betId = `${bet.id}_${bet.handicap}`;
                                        return (
                                            <li key={i}>
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id={"print-odds-checkbox" + i} checked={state.selectedBets[betId] !== undefined} onChange={() => state.toggleBet(betId, bet)} />
                                                    <label className="custom-control-label" htmlFor={"print-odds-checkbox" + i}>{bet.desc}</label>
                                                </div>
                                            </li>
                                        )
                                    })}
                                </ul>
                                :
                                <div className="d-flex align-items-center justify-center">
                                    <p className="ml-auto mr-auto grassetto">{getLabel('mybets.nessunascommessa')}</p>
                                </div>
                            }
                        </div>
                    }
                    <iframe title="print-odds-iframe" style={{display: 'none'}} ref={iframeRef}>
                        {state.groups && iframeRef.current && ReactDOM.createPortal(<PrintIframeContent groups={state.groups}
                                                                                                        groupByBet={state.groupByBet}
                                                                                                        settings={state.settings}/>, iframeRef.current.contentWindow.document.body)}
                    </iframe>
                    <div className="strumenti-stampa box-paese" id="strumenti-stampa">
                        <div className="strumento">
                            <p className="margine-giu">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval')}</p>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="intervallo1" name="intervallo1" className="custom-control-input" onChange={() => state.setRange('TODAY')} />
                                <label className="custom-control-label" htmlFor="intervallo1">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.today')}</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="intervallo2" name="intervallo1" className="custom-control-input" onChange={() => state.setRange('TOMORROW')} />
                                <label className="custom-control-label" htmlFor="intervallo2">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.tomorrow')}</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="intevallo3" name="intervallo1" className="custom-control-input" defaultChecked={true} onChange={() => state.setRange('ALL')} />
                                <label className="custom-control-label" htmlFor="intevallo3">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.all')}</label>
                            </div>
                            <div className="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="selezionaDataStampa" name="intervallo1" className="custom-control-input" onChange={() => state.setRange(null, getSysDateInFormat('YYYY-MM-DD', 0), getSysDateInFormat('YYYY-MM-DD', 1))} />
                                <label className="custom-control-label" htmlFor="selezionaDataStampa">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.by_date')}</label>
                            </div>
                            {state.settings.range == null &&
                                <div className="box-date-stampa margine-su" id="date-stampa">
                                    <div className="form-group">
                                        <div className="bg-bianco" data-target="#datetimepicker1" data-toggle="datetimepicker">
                                            <div className="testo-filtro-data margine-dx-mezzo"><span className="data-span">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.from')}</span><i className="fa fa-calendar colore-1"></i></div>
                                        </div>
                                        <div className="input-group date" id="datetimepicker1" data-target-input="nearest">
                                            <input type="text" className="form-control datetimepicker-input" data-target="#datetimepicker1" defaultValue={todayDate} onChange={setDateFrom} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="input-group date" id="datetimepicker2" data-target-input="nearest">
                                            <div className="bg-bianco" data-target="#datetimepicker2" data-toggle="datetimepicker">
                                                <div className="testo-filtro-data margine-dx-mezzo"><span className="data-span">{getLabel('prematch_page.print_bets.bets_selection_window.options.interval.to')}</span><i className="fa fa-calendar colore-1"></i></div>
                                            </div>
                                            <input type="text" className="form-control datetimepicker-input" data-target="#datetimepicker2" defaultValue={tomorrowDate} onChange={setDateTo} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <hr />
                        <div className="strumento">
                            <div className="colonne-3">
                                <div className="colonna">
                                    <p className="margine-giu">{getLabel('prematch_page.print_bets.bets_selection_window.options.orientation')}</p>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervalloa-2" name="orientamento" className="custom-control-input" defaultChecked={state.settings.align === 'vertical'} onChange={() => state.setAlignment('vertical')} />
                                        <label className="custom-control-label" htmlFor="intervalloa-2">{getLabel('prematch_page.print_bets.bets_selection_window.options.orientation.vertical')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervalloa-1" name="orientamento" className="custom-control-input" defaultChecked={state.settings.align === 'horizontal'} onChange={() => state.setAlignment('horizontal')} />
                                        <label className="custom-control-label" htmlFor="intervalloa-1">{getLabel('prematch_page.print_bets.bets_selection_window.options.orientation.horizontal')}</label>
                                    </div>
                                </div>
                                <div className="colonna">
                                    <p className="margine-giu">{getLabel('prematch_page.print_bets.bets_selection_window.options.font_size')}</p>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervallob-1" name="dimensione" className="custom-control-input" onChange={() => state.setFontSize('small')} />
                                        <label className="custom-control-label" htmlFor="intervallob-1">{getLabel('prematch_page.print_bets.bets_selection_window.options.font_size.small')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervallob-2" name="dimensione" className="custom-control-input" defaultChecked={true} onChange={() => state.setFontSize('medium')} />
                                        <label className="custom-control-label" htmlFor="intervallob-2">{getLabel('prematch_page.print_bets.bets_selection_window.options.font_size.medium')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervallob-3" name="dimensione" className="custom-control-input" onChange={() => state.setFontSize('big')} />
                                        <label className="custom-control-label" htmlFor="intervallob-3">{getLabel('prematch_page.print_bets.bets_selection_window.options.font_size.big')}</label>
                                    </div>
                                </div>
                                <div className="colonna">
                                    <p className="margine-giu">{getLabel('prematch_page.print_bets.bets_selection_window.options.sort_type')}</p>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervalloc-1" name="ordinamento" className="custom-control-input" defaultChecked={true} onChange={() => state.setSortType('date') }/>
                                        <label className="custom-control-label" htmlFor="intervalloc-1">{getLabel('prematch_page.print_bets.bets_selection_window.options.sort_type.date')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervalloc-2" name="ordinamento" className="custom-control-input" onChange={() => state.setSortType('tournament') }/>
                                        <label className="custom-control-label" htmlFor="intervalloc-2">{getLabel('prematch_page.print_bets.bets_selection_window.options.sort_type.tournament')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervalloc-3" name="ordinamento" className="custom-control-input" onChange={() => state.setSortType('dateAndTournament') }/>
                                        <label className="custom-control-label" htmlFor="intervalloc-3">{getLabel('prematch_page.print_bets.bets_selection_window.options.sort_type.date_and_tournament')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="strumento margine-giu">
                            <div className="colonne-3">
                                <div className="colonna">
                                    <p className="margine-giu">{getLabel('prematch_page.print_bets.bets_selection_window.options.print_logo')}</p>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervallo-logo-1" name="stampa-logo" className="custom-control-input" defaultChecked={true} onChange={() => state.setLogoOnAllPages(true)} />
                                        <label className="custom-control-label" htmlFor="intervallo-logo-1">{getLabel('prematch_page.print_bets.bets_selection_window.options.print_logo.on_each_page')}</label>
                                    </div>
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="intervallo-logo-2" name="stampa-logo" className="custom-control-input" onChange={() => state.setLogoOnAllPages(false)} />
                                        <label className="custom-control-label" htmlFor="intervallo-logo-2">{getLabel('prematch_page.print_bets.bets_selection_window.options.print_logo.only_on_first_page')}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="strumento allinea-centro">
                            <a href-disabled="#!" role="button" tabIndex="0" className="pointer bottone-exa bg-colore-1 bianco bordo-tondo" onClick={handlePrint}>{getLabel('prematch_page.print_bets.bets_selection_window.print')}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="widget-sel">
                <a href-disabled="#!" role="button" tabIndex="0" className="pointer bottone-w-sel bianco" onClick={handleCheckAll}><i className="fas fa-check"></i></a>
                <a href-disabled="#!" role="button" tabIndex="0" className="pointer bottone-w-sel bianco" onClick={handlePrint}><i className="fas fa-print"></i></a>
                <a href-disabled="#!" role="button" tabIndex="0" className="pointer bottone-w-sel bianco" onClick={handleClose}><i className="fas fa-times"></i></a>
            </div>
        </div>
    );
}

export default PrintOdds;
